import React from "react";

import ListItem from "../../components/ListItem";
import Link from "../../components/Link";
import Image from "../../components/Image";

import { TopperItem } from "../../../../types";

/**
 * This variant represents display type 3
 * @param url
 * @param itemId
 * @param image
 */
const ImageAndTooltip = ({ url, itemId, image }: TopperItem) => (
  <ListItem>
    <Link
      className="max-w-[220px]"
      href={url}
      data-testid={`topper-item-${itemId}`}
    >
      <Image
        src={image}
        width="1"
        height="1"
        className="max-w-none h-20 w-20"
        loading="eager"
        alt=""
      />
    </Link>
  </ListItem>
);

export default ImageAndTooltip;
